/* Zarpa Premium — micro-animaciones de aparición al hacer scroll.
   Progresivo y seguro: sin JS o con "reducir movimiento" activado,
   la página se ve exactamente igual que antes (todo visible). */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var EXCLUDE =
    '.buy-buttons-block, product-form-component, variant-picker-component, ' +
    'variant-picker, [id^="BuyButtons"], .quantity-selector, sticky-add-to-cart, ' +
    '.slideshow-controls, media-gallery, .media-gallery__grid';

  var CANDIDATES = [
    '#MainContent .group-block-content > .text-block',
    '#MainContent .group-block-content > .button',
    '#MainContent .group-block-content > .button-custom',
    '#MainContent .group-block-content > .button-secondary',
    '#MainContent .group-block-content > .group-block',
    '#MainContent .section-content-wrapper > .text-block',
    '#MainContent .accordion details',
    '#MainContent product-card, #MainContent .product-card',
    '#MainContent .section-content-wrapper:not(.layout-panel-flex)'
  ].join(', ');

  function collect() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(CANDIDATES));

    nodes = nodes.filter(function (el) {
      if (el.closest(EXCLUDE)) return false;
      return true;
    });

    // Si un candidato está dentro de otro candidato, se queda solo el padre
    // (evita animaciones dobles anidadas).
    var filtered = nodes.filter(function (el) {
      var p = el.parentElement;
      while (p) {
        if (nodes.indexOf(p) !== -1) return false;
        p = p.parentElement;
      }
      return true;
    });

    return filtered;
  }

  function init() {
    var els = collect();
    if (!els.length) return;

    document.documentElement.classList.add('zarpa-motion');

    // Retardo escalonado por sección (70 ms entre hermanos, tope 350 ms)
    var sectionCounts = new Map();
    els.forEach(function (el) {
      var section = el.closest('.shopify-section') || document.body;
      var n = sectionCounts.get(section) || 0;
      sectionCounts.set(section, n + 1);
      el.style.setProperty('--zarpa-delay', Math.min(n * 70, 350) + 'ms');
      el.classList.add('zarpa-reveal');
    });

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('zarpa-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);
    });

    // Cinturón de seguridad: pase lo que pase, a los 3 s todo visible.
    setTimeout(function () {
      els.forEach(function (el) {
        el.classList.add('zarpa-in');
      });
    }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
